<template>
  <div class="table-list">
    <div v-if="!noHeader" class="table-list-header">
      <el-tabs v-model="biddingRoundNo" class="table-list-tabs" @tab-click="changeTab">
        <el-tab-pane
          v-for="(item, index) in roundsList"
          :key="index"
          :label="$t('bidmanagementpur.biddingmonitoring.tabRounds', [`${item.biddingRoundNo}`, $t(`bidmanagementpur.biddingmonitoring.hidePrice.${item.hidePriceSign}`)])"
          :name="item.biddingRoundNo"
        />
      </el-tabs>
      <ButtonTabs v-if="!noBtns" :btn-config="btnConfig" @input="changeBtnTab" />
    </div>
    <TableItem
      v-for="(item, index) in list"
      :key="index"
      :data="item"
      :index="index"
      :search-type="searchType"
    />
    <ZlTable v-if="!list.length" />
  </div>
</template>

<script>
import ButtonTabs from '@/components/common/button-tabs'
import ZlTable from '@utils/table/components/table'
import TableItem from './table-item'
// import http from '@/plugin/axios'
const btnConfig = {
  default: 'supplier',
  btns: [
    { text: 'bidmanagementpur.biddingmonitoring.btnConfig[0]', value: 'supplier' },
    { text: 'bidmanagementpur.biddingmonitoring.btnConfig[1]', value: 'item' }
  ]
}
export default {
  components: {
    ButtonTabs,
    ZlTable,
    TableItem
  },
  props: {
    noHeader: {
      type: Boolean
    },
    noBtns: {
      type: Boolean
    },
    data: {
      type: Object,
      default: () => ({})
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      biddingRoundNo: '',
      searchType: 'supplier'
    }
  },
  computed: {
    btnConfig() {
      return btnConfig
    },
    currentRound() {
      return this.data.currentRound || this.data.biddingRounds
    },
    roundsList() {
      return this.data.roundsList || []
    }
  },
  created() {
    this.biddingRoundNo = `${this.currentRound}`
    this.search()
  },
  methods: {
    changeTab({ name: biddingRoundNo }) {
      this.biddingRoundNo = biddingRoundNo
      this.search()
    },
    changeBtnTab(searchType) {
      this.searchType = searchType
      this.search()
    },
    search() {
      this.$emit('search', { biddingHeadId: this.$route.params.id, biddingRoundNo: this.biddingRoundNo, searchType: this.searchType })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-list {
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    background: #fff;
  }
  &-tabs {
    flex-grow: 1;
  }
}
</style>
